import { IUserTypeEnum } from 'types/FMSGraphqlTypes'
import * as yup from 'yup'
import { IMotorCarrierForCurrentUserFragment } from '../graphql/MotorCarrierForCurrentUserFragment'
import { IMotorCarrierUserForCurrentUserFragment } from '../graphql/MotorCarrierUserForCurrentUserFragment'

/**
 * @description Validates if the current user has permission to book loads for the selected carrier.
 */
export const bookingPermissionTestOptions: yup.TestOptions = {
  name: 'has-permission-to-book',
  message: 'You don’t have permission to book loads for this carrier.',
  test(this, value) {
    const { type: userType } = value as IMotorCarrierUserForCurrentUserFragment
    return userType === IUserTypeEnum.dispatcher || userType === IUserTypeEnum.owner_operator
  },
}

export const MotorCarrierUserForCurrentUserSchema = yup.object<
  IMotorCarrierUserForCurrentUserFragment
>({
  /**
   * @example '123'
   */
  id: yup.string().required(),
  /**
   * @example 'dispatcher'
   */
  type: yup.mixed<IUserTypeEnum>().oneOf(Object.values(IUserTypeEnum)).required(),
  /**
   * @example { id: '123', name: 'Trucker Inc.', dotNumber: 1234567, mcNumber: 7654321 }
   */
  motorCarrier: yup.object<IMotorCarrierForCurrentUserFragment>({
    id: yup.string().required(),
    name: yup.string().required(),
    dotNumber: yup.number().required(),
    mcNumber: yup.number().nullable().notRequired(),
  }),
})
